/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Instructions_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Say who the result is for, what it works from, what it should hand back and in what form. Concrete details, like a format, a length or a deadline, help more ..." |
*
* @param {Uno_Edu_Agent_Instructions_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_instructions_chip1_answer = /** @type {((inputs?: Uno_Edu_Agent_Instructions_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Instructions_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sagen Sie, für wen das Ergebnis ist, womit der Agent arbeitet, was er zurückgeben soll und in welcher Form. Konkrete Angaben wie Format, Länge oder Frist helfen mehr als allgemeine Wünsche.")
	return /** @type {LocalizedString} */ ("Say who the result is for, what it works from, what it should hand back and in what form. Concrete details, like a format, a length or a deadline, help more than general wishes.")
});